export const Anrede = [
  { value: '', label: 'Keine Angabe' },
  { value: 'ohne Anrede', label: 'ohne Anrede' },
  { value: 'Herr', label: 'Herr' },
  { value: 'Frau', label: 'Frau' },
];

export const gewerk = [
  { value: 'BODEN', label: 'Fliesen-, Platten, Bodenbeläge' },
  { value: 'ELEKTRO', label: 'Elekroinstallation' },
  { value: 'HEIZUNG', label: 'Heizungsarbeiten' },
  { value: 'MALER_PUTZ', label: 'Maler- und Putzarbeiten' },
  { value: 'GAS_SANITAER', label: 'Gas- und Sanitärinstallation' },
  { value: 'REINIGUNG', label: 'Reinigungsarbeiten' },
  { value: 'METALL_TISCHLER', label: 'Metall und Tischlerarbeiten, Fenster und Türen' },
  { value: 'AUSSEN', label: 'Außenbereich, Tiefbau, Landschaftsbau' },
  { value: 'MAURER_ROHBAU', label: 'Maurer- und Rohbauarbeiten' },
  { value: 'DACH', label: 'Dacharbeiten' },
  { value: 'KLIMA', label: 'Klima- und Lüftungsanlagen' },
  { value: 'SCHUTZ', label: 'Brandschutz- und Sicherheitstechnik' },
  { value: 'SICHERHEIT', label: 'Sicherheitstechnik' },
  { value: 'AUFZUG', label: 'Aufzugstechnik' },
  { value: 'KOMMUNIKATION', label: 'Kommunikationsanlagen' },
  { value: 'SONSTIGES', label: 'Sonstige Arbeiten' },
];

export const umkreis = [
  { value: '10', label: '10 km' },
  { value: '25', label: '25 km' },
  { value: '50', label: '50 km' },
  { value: '100', label: '100km' },
  { value: '0', label: 'unbegrenzt' },
];

export interface Land {
  value: string;
  label: string;
}

export const Laender: Land[] = [
  { value: '', label: 'Keine Angabe' },
  { value: 'Deutschland', label: 'Deutschland' },
  { value: 'Belgien', label: 'Belgien' },
  { value: 'Estland', label: 'Estland' },
  { value: 'Frankreich', label: 'Frankreich' },
  { value: 'Irland', label: 'Irland' },
  { value: 'Island', label: 'Island' },
  { value: 'Italien', label: 'Italien' },
  { value: 'Kroatien', label: 'Kroatien' },
  { value: 'Lettland', label: 'Lettland' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'Litauen', label: 'Litauen' },
  { value: 'Luxemburg', label: 'Luxemburg' },
  { value: 'Niederlande', label: 'Niederlande' },
  { value: 'Österreich', label: 'Österreich' },
  { value: 'Polen', label: 'Polen' },
  { value: 'Rumänien', label: 'Rumänien' },
  { value: 'Russische Föderation', label: 'Russische Föderation' },
  { value: 'Schweden', label: 'Schweden' },
  { value: '039', label: 'Schweiz' },
  { value: 'Schweiz', label: 'Slowakei' },
  { value: 'Slowenien', label: 'Slowenien' },
  { value: 'Tschechische Republik', label: 'Tschechische Republik' },
  { value: 'Türkei', label: 'Türkei' },
  { value: 'Ukraine', label: 'Ukraine' },
  { value: 'Ungarn', label: 'Ungarn' },
];
